import Alpine from 'alpinejs';
import axios from '../../config/axios.js';

const emptyForm = () => ({
  title: '',
  description: '',
  starts_at: '',
  ends_at: '',
  is_active: true,
});

function createKasirFlashSale() {
  return {
    sales: [],
    modal: false,
    productModal: false,
    busy: false,
    form: emptyForm(),
    /** @type {Array<{product_id:string,name:string,normal_price:number,sale_price:number,stock_limit:string|number|null}>} */
    formProducts: [],
    activeSale: null,
    productForm: { product_id: '', name: '', normal_price: 0, sale_price: '', stock_limit: '' },
    productQuery: '',
    productSuggestions: [],
    showProductSuggest: false,
    productTimer: null,
    /** konteks pencarian: 'create' | 'existing' */
    productSearchCtx: 'create',

    init() {
      try {
        const cfg = JSON.parse(this.$el.getAttribute('data-config') || '{}');
        this.sales = Array.isArray(cfg.sales) ? cfg.sales : [];
      } catch (e) {
        console.error('kasirFlashSale config', e);
        this.sales = [];
      }
    },

    openCreate() {
      this.form = emptyForm();
      this.formProducts = [];
      this.resetProductPicker();
      const start = new Date();
      const end = new Date(start.getTime() + 24 * 60 * 60 * 1000);
      this.form.starts_at = this.toLocalInput(start);
      this.form.ends_at = this.toLocalInput(end);
      this.productSearchCtx = 'create';
      this.modal = true;
    },

    toLocalInput(d) {
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    resetProductPicker() {
      this.productForm = { product_id: '', name: '', normal_price: 0, sale_price: '', stock_limit: '' };
      this.productQuery = '';
      this.productSuggestions = [];
      this.showProductSuggest = false;
    },

    closeModals() {
      this.modal = false;
      this.productModal = false;
      this.activeSale = null;
      this.showProductSuggest = false;
    },

    onProductSearch() {
      clearTimeout(this.productTimer);
      const q = (this.productQuery || '').trim();
      if (q.length < 2) {
        this.productSuggestions = [];
        this.showProductSuggest = false;
        return;
      }
      this.productTimer = setTimeout(() => this.fetchProducts(q), 250);
    },

    async fetchProducts(q) {
      try {
        const { data } = await axios.get('/api/v1/kasir/products', {
          params: { search: q, per_page: 10 },
        });
        this.productSuggestions = data.data || [];
        this.showProductSuggest = this.productSuggestions.length > 0;
      } catch {
        this.productSuggestions = [];
        this.showProductSuggest = false;
      }
    },

    pickProduct(p) {
      const price = Number(p.price || 0);
      this.productForm.product_id = p.id;
      this.productForm.name = p.name || p.title || p.id;
      this.productForm.normal_price = price;
      this.productForm.sale_price = price > 0 ? Math.max(0, Math.floor(price * 0.8)) : '';
      this.productQuery = this.productForm.name;
      this.showProductSuggest = false;
      this.productSuggestions = [];
    },

    addProductToForm() {
      if (!this.productForm.product_id) {
        window.toast?.('Pilih produk dari saran pencarian.', 'error');
        return;
      }
      if (this.productForm.sale_price === '' || Number(this.productForm.sale_price) < 0) {
        window.toast?.('Isi harga sale.', 'error');
        return;
      }
      if (this.formProducts.some((x) => x.product_id === this.productForm.product_id)) {
        window.toast?.('Produk sudah ada di daftar.', 'info');
        return;
      }

      this.formProducts.push({
        product_id: this.productForm.product_id,
        name: this.productForm.name,
        normal_price: this.productForm.normal_price,
        sale_price: Number(this.productForm.sale_price),
        stock_limit: this.productForm.stock_limit || null,
      });
      this.resetProductPicker();
      window.toast?.('Produk ditambahkan ke daftar.', 'success');
    },

    removeFormProduct(idx) {
      this.formProducts.splice(idx, 1);
    },

    async save() {
      if (!this.form.title?.trim()) {
        window.toast?.('Judul wajib diisi.', 'error');
        return;
      }
      if (!this.form.starts_at || !this.form.ends_at) {
        window.toast?.('Jadwal mulai & selesai wajib diisi.', 'error');
        return;
      }
      if (!this.formProducts.length) {
        window.toast?.('Tambahkan minimal 1 produk ke flash sale.', 'error');
        return;
      }

      this.busy = true;
      try {
        const { data } = await axios.post('/api/v1/kasir/engagement/flash-sales', {
          title: this.form.title,
          description: this.form.description || null,
          starts_at: this.form.starts_at,
          ends_at: this.form.ends_at,
          is_active: true,
          products: this.formProducts.map((p) => ({
            product_id: p.product_id,
            sale_price: Number(p.sale_price),
            stock_limit: p.stock_limit ? Number(p.stock_limit) : null,
          })),
        });
        const item = data.data || {};
        this.sales.unshift({
          ...item,
          products_count: item.products?.length || this.formProducts.length,
        });
        this.modal = false;
        this.formProducts = [];
        window.toast?.(data.message || 'Flash sale dibuat.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal membuat flash sale.', 'error');
      } finally {
        this.busy = false;
      }
    },

    openAddProduct(sale) {
      this.activeSale = sale;
      this.productSearchCtx = 'existing';
      this.resetProductPicker();
      this.productModal = true;
    },

    async saveProduct() {
      if (!this.activeSale?.id) return;
      if (!this.productForm.product_id) {
        window.toast?.('Pilih produk dulu.', 'error');
        return;
      }
      if (this.productForm.sale_price === '' || Number(this.productForm.sale_price) < 0) {
        window.toast?.('Harga sale wajib diisi.', 'error');
        return;
      }

      this.busy = true;
      try {
        const payload = {
          product_id: this.productForm.product_id,
          sale_price: Number(this.productForm.sale_price),
        };
        if (this.productForm.stock_limit) {
          payload.stock_limit = Number(this.productForm.stock_limit);
        }
        const { data } = await axios.post(
          `/api/v1/kasir/engagement/flash-sales/${this.activeSale.id}/products`,
          payload,
        );
        const updated = data.data;
        const idx = this.sales.findIndex((s) => s.id === this.activeSale.id);
        if (idx >= 0 && updated) {
          this.sales.splice(idx, 1, {
            ...updated,
            products_count: updated.products?.length || updated.products_count || 0,
          });
        }
        this.productModal = false;
        window.toast?.(data.message || 'Produk ditambahkan.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menambah produk.', 'error');
      } finally {
        this.busy = false;
      }
    },

    async remove(s) {
      const ok = window.confirmDialog
        ? await window.confirmDialog({
            title: 'Hapus flash sale?',
            message: s.title,
            confirmText: 'Hapus',
            variant: 'danger',
          })
        : window.confirm('Hapus flash sale ini?');
      if (!ok) return;

      try {
        await axios.delete('/api/v1/kasir/engagement/flash-sales/' + s.id);
        this.sales = this.sales.filter((x) => x.id !== s.id);
        window.toast?.('Flash sale dihapus.', 'success');
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal menghapus.', 'error');
      }
    },
  };
}

Alpine.data('kasirFlashSale', createKasirFlashSale);
